import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";

const AddLead = ({ show, onClose }) => {
    const option_area = [
        { value: "0", label: "KK Nagar" },
        { value: "1", label: "Vandiyur" },
        { value: "2", label: "80 Feet Road" },
        { value: "3", label: "Goripalayam" },
    ];
    const delivery_point = [
        { value: "0", label: "Anna Nagar" },
        { value: "1", label: "Periyar Nagar" },
        { value: "2", label: "Kamarajar Nagar" },
    ];
    const lead_type = [
        { value: "0", label: "Company" },
        { value: "1", label: "Individual" },
        { value: "2", label: "College" },
    ];
    const options_product = [
        { value: "0", label: "Break Box Mini" },
        { value: "1", label: "Break Box Regular" },
        { value: "2", label: "Lunch Box Mini" },
        { value: "3", label: "Lunch Box Regular" },
        { value: "4", label: "Lunch Box Anjaraipetti" },
        { value: "5", label: "Dinner Box Mini Package" },
        { value: "6", label: "Dinner Box Regular" },
    ];
    
    const lead_source = [
        { value: "0", label: "Website" },
        { value: "1", label: "Advertisement" },
        { value: "2", label: "Face Book" },
    ];
    const [selectedOption, setSelectedOption] = useState(null);
    const [isFocused] = useState(false);
    useEffect(() => {
        if (isFocused) {
            console.log('The input is focused!');
        }
    }, [isFocused]);

    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Add Raw Material</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Raw Material<span className="required">*</span></label>
                            <Select
                                defaultValue={selectedOption}
                                onChange={setSelectedOption}
                                options={option_area}
                                placeholder="Select Area"
                            />
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Brand Name</label>
                            <input type="text" className="form-control" placeholder="Enter Brand Name" />
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Quantity<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Qty" />
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Unit<span className="required">*</span></label>
                            <Select  placeholder="Select Unit"
                                defaultValue={selectedOption}
                                onChange={setSelectedOption}
                                options={lead_source}
                            />
                        </div>
                        
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Enter Amount<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Amount" />
                        </div>
                        
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Add Rawmaterial
                         <i className="fas fa-angle-double-right ms-2"></i>
                         </Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddLead;
